export default __webpack_public_path__ + "static/media/mon_24.a7c3ad30.png";